import { useCallback } from "react";

import { createFiltersFromFilterData } from "../../../../utils/formViews";

import { Filter, ComplexFilter } from "../../../common/hooks/useLocalTable";
import useEntityFormViewTable from "../../../common/hooks/useEntityFormViewTable";
// import RiskLevelsActions from "components/admin/transaction/risk-levels/risk-levels-actions";

const getFilters = (searchString, filterData) => {
    const filters = [];

    if (searchString) {
        filters.push(
            new ComplexFilter([new Filter("description", Filter.CO, searchString), new Filter("riskId", Filter.CO, searchString)], ComplexFilter.OR)
        );
    }

    if (filterData) {
        const createdFilters = createFiltersFromFilterData(filterData);
        filters.push(...createdFilters);
    }
    return filters;
};

const useRisksTable = (risks) => {
    const getDialogFilters = useCallback(
        async ({ field, search = "" }) => {
            const lowerSearch = search.toLowerCase();
            let keys;

            switch (field) {
                case "riskId": {
                    keys = risks.filter(({ riskId }) => riskId?.toLowerCase().includes(lowerSearch)).map(({ riskId }) => riskId);
                    break;
                }
            }

            const uniqueKeys = [...new Set(keys)];
            const rows = uniqueKeys.map((key) => ({ key, text: key }));
            return { rows, total: rows?.length };
        },
        [risks]
    );

    const viewTable = useEntityFormViewTable(risks, getFilters);

    return {
        ...viewTable,
        getDialogFilters,
    };
};

export default useRisksTable;
